export default __webpack_public_path__ + "locales/cs/ResetApplicationDialog.json?hash=46d7062f7e16bacec4bfe8a1d49ead8e";